import React from 'react'
import { Breakpoint } from 'react-socks'

export default ({ children }) => (
  <Breakpoint mobileUp down>
    {children}
  </Breakpoint>
)
